// src/components/PageContent.js
import styled from 'styled-components'

const PageContent = styled.div`
  
`

export default PageContent